export { default as SecurityPostureTable } from "./SecurityPostureTable";
